export const indigo = {
  900: '#05175E',
  800: '#082188',
  700: '#0A29A6',
  600: '#0B2FBF',
  500: '#0D35D5',
  400: '#637CE3',
  300: '#90A3EB',
  200: '#B3BFF1',
  100: '#D0D7F6',
  50: '#E8ECFB',
}
